<template>
  <div
    class="border p-4 grid grid-cols-auto-1 gap-3 items-center hover:bg-gray-200 cursor-pointer min-h-20"
    :style="{borderColor: category.color}"
    @click="goTo('/activity-category-manage/' + category.id)"
  >
    <div class="-mt-1" :style="{color: category.color}">
      <icon :name="category.icon" size="1.5em" />
    </div>
    <h3 class="m-0">{{ category.title}}</h3>
  </div>
</template>

<script>
import { ActivityCategory } from "@/modules/activities/viewmodels/ActivityCategory";

export default {
  name: "ActivityCategory",
  data() {
    return {};
  },
  props: {
    category: {
      type: ActivityCategory,
      required: true
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>